import {BrowserModule} from '@angular/platform-browser';
import {NgModule, SystemJsNgModuleLoader} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule, JsonpModule} from '@angular/http';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {LoginComponent} from './login/login.component';
import {CpcWebApiService} from './cpc-web-api.service';
import {ModMenuService} from 'app/home-page/mod-menu.service';
import {CpcSysInfoService} from './cpc-sys-info.service'
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppService} from './app.service';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {FileUploadModule} from 'ng2-file-upload';
import { MobileLoginComponent } from './mobile-login/mobile-login.component';
import {QRCodeModule} from 'angular2-qrcode';
import {InterfaceSubjectService} from './cpc-services/interface.subject.service';
import {ButtonModule, DialogModule, DropdownModule, MessageModule} from 'primeng/primeng';
import {MessageService} from 'primeng/components/common/messageservice';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {MqttService} from './home-page/mqtt.service';

export function HttpLoaderFactory(http: HttpClient) {
  const version =  Math.floor(Math.random() * 1000000);
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + version);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    MobileLoginComponent,

  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    JsonpModule,
    AppRoutingModule,
    FileUploadModule,
    QRCodeModule,
    MessageModule,
    DialogModule,
    ButtonModule,
    DropdownModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  },
    CpcWebApiService,
    SystemJsNgModuleLoader,
    ModMenuService,
    MessageService,
    CpcSysInfoService,
    InterfaceSubjectService,
    AppService,
    MqttService,
  ],
  bootstrap: [AppComponent]
})


export class AppModule {
}



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/app.module.ts